<!--
	_('attestation-presence-fae-ach')
	_('attestation-presence-fae-ama')
	_('attestation-presence-fae-th-tsh')
	_('attestation-presence-demo-tractr')

	_('modal_delete_document_title')
	_('modal_delete_document_content')
	_('modal_delete_document_ok')
-->

<div class="container-fluid px-0 px-xl-5 py-4 py-xl-5">
	<div class="container-xl px-xl-0 ml-0">
		<ng-container *ngIf="formation && formationSession && !loading">
			<!-- Session Card -->
			<app-atom-formation-session-card-detail
				[session]="formationSession"
				[numberInterventions]="numberIntervention"
				[formation]="formation"
			></app-atom-formation-session-card-detail>
		</ng-container>
		<div
			class="d-flex flex-wrap justify-content-between align-items-center header__formations"
		>
			<h2 class="mb-0">
				{{ 'formation-intervention-list-admin-title' | translate }}
			</h2>
		</div>
	</div>

	<div *ngIf="!loading" class="container-xl ml-0 mb-5">
		<ng-container
			*ngIf="
				formationInterventions && formationInterventions.length > 0;
				else emptyTpl
			"
		>
			<div class="row">
				<div class="col-12">
					<app-atom-formation-intervention-table
						[formationInterventions]="formationInterventions"
						[sessionId]="sessionId"
					></app-atom-formation-intervention-table>
				</div>
			</div>
		</ng-container>
	</div>

	<div *ngIf="!loading" class="container-xl ml-0 pt-6">
		<!-- ATTESTATIONS DE PRESENCE -->
		<app-atom-formation-table-attestation-presence
			#attestationPresenceTable
			[title]="'formation-session-attestation-presence-title' | translate"
			[sessionId]="formationSession?.props?._id"
			[respondants]="respondants"
			[templateOptions]="attestationTemplateOptions"
			[defaultTemplate]="defaultTemplate"
			[disableSend]="false"
			[disableDelete]="false"
			[disableGenerate]="isGenerateDisable('attestation_presence')"
			[generateLoading]="attestationPresenceLoading"
			(emitGenerate)="handleGenerate($event, 'attestation_presence')"
			(emitGenerateForRespondant)="handleGenerateForRespondant($event)"
			(emitReadDocument)="handleReadDocumentAttestationPresence($event)"
			(emitDownloadDocument)="
				handleDownloadDocumentAttestationPresence($event)
			"
			(emitSendDocument)="handleSendAttestationPresence($event)"
			(emitDeleteDocument)="
				showDeleteConfirmOnAttestationPresence($event)
			"
			(emitSendGrouped)="handleSendAllAttestationPresence()"
			(emitBulkGenerate)="handleBulkGenerate($event)"
			(emitBulkSend)="handleBulkSend($event)"
			(emitBulkDelete)="handleBulkDelete($event)"
			(emitBulkDownload)="handleBulkDownloadAttestationPresence($event)"
		></app-atom-formation-table-attestation-presence>
	</div>
</div>

<!-- Loading -->
<ng-template #loadingTpl>
	<div class="text-center">
		<app-atom-concept-loader></app-atom-concept-loader>
	</div>
</ng-template>
<!-- /Loading -->

<!-- Empty list -->
<ng-template #emptyTpl>
	<div class="col-12 py-4 card-container empty">
		<p>{{ 'formation-intervention-list-empty' | translate }}</p>
	</div>
</ng-template>
<!-- /Empty list -->
